import React from 'react';
import PersonInfoButton from '@ctsu/person-i-button';
import { ATCONSTANTS as ATC } from 'appconstants';
import { getToken } from '@ctsu/loader';
import { useUsername } from 'helpers';
import { RenderElement } from 'components/RenderHelpers';
import { CanUserViewIbutton } from 'appconstants/Permission';

function PersonIButton({ personCtepId }) {
  const userName = useUsername();

  const canViewIButton = CanUserViewIbutton();

  return !personCtepId ? null : (
    <RenderElement access={canViewIButton}>
      <PersonInfoButton
        id={personCtepId}
        color="#13808F"
        dataId={`${ATC.PACKETID}${personCtepId}PERSON_I_BUTTON${ATC.BUTTON}`}
        getToken={getToken}
        smallSize
        userName={userName}
      />
    </RenderElement>
  );
}

export default PersonIButton;
